export const environment = {
  production: true,
  envName: 'mod',
  //GOOGLE_ANALYTICS_ID: 'UA-102407045-2',
  MEASUREMENT_ID:'G-TYCSDJYJE5',
  CLMTLK_WS_BASE_URL: 'https://apismod.plymouthrock.com/edge/claimstalk-ws/'
};



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/CLAIMS_PIPELINE/CLMTLK_UI_APP_PIPELINE/src/environments/environment.ts